import styled, { css, StyledComponent } from 'styled-components';
import {
  AutoComplete as AutoCompleteEnhancement,
  IAutoComplete,
} from '@src/emp-3.0/components/common/AntdEnhancement';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  border-radius: 4px;
  border: 1px solid #bfbfbf;
  width: 100%;
  background: #f5f5f5;
  margin: 10px 0px;
`;

export const Header = styled.div`
  display: flex;
  padding: 10px 12px;
  gap: 8px;

  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  /* background: #f5f5f5; */
  align-items: center;
  justify-content: space-between;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  padding: 0 12px 12px 0;
`;

export const AddRulesButton: StyledComponent<'div', any, { disabled?: boolean }> = styled.div<{
  disabled?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px 0 8px;
  align-items: center;
  gap: 6px;

  border-radius: 4px;
  border: 1px solid #bfbfbf;
  background: #e6edff;

  color: #bfbfbf;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.14px;
  cursor: pointer;

  ${(props) => {
    if (props?.disabled) {
      return css`
        opacity: 0.4;
      `;
    }
    return;
  }}
`;

export const Footer = styled.div`
  display: flex;
  padding: 0 12px 16px 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;
export const PopupContainer = styled.div`
  min-width: 484px;
  padding-left: 8px;
  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    color: #333;
    font-weight: 600;
  }
  .popup-content-item {
    display: flex;
    color: #494949;
    margin-bottom: 16px;
    > div:first-child {
      width: 114px;
      margin-right: 10px;
    }
  }
  .popup-footer {
    margin-top: 14px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
`;

export const AutoComplete = styled(AutoCompleteEnhancement)<IAutoComplete>`
  &&.emp-ant-select {
    .emp-ant-select-selector {
      height: 28px;
      border-radius: 3px;
      border: solid 1px #bfbfbf;
      width: 100%;
      .emp-ant-select-selection-search-input {
        height: 100%;
      }

      .emp-ant-select-selection-item {
        /* font-weight: 500; */
        letter-spacing: -0.01em;
        line-height: 26px;
      }

      .emp-ant-select-selection-search {
        height: 28px;

        // ⬇️Overlay antd Input style
        .emp-ant-input-affix-wrapper {
          border-color: ${(props) => (props.status === 'error' ? '#ff4d4f' : 'transparent')};

          padding: 0 20px 0 11px;

          .emp-ant-input {
            /* font-weight: 500; */

            &::placeholder {
              color: rgba(0, 0, 0, 0.25);
              /* font-weight: 500; */
            }
          }
        }

        &:hover .emp-ant-input-affix-wrapper {
          border-color: #2969ff;
        }

        // ⬆️
      }
    }

    .emp-ant-select-selection-placeholder {
      color: rgba(0, 0, 0, 0.45);
      /* font-weight: 500; */
      line-height: 28px;
      letter-spacing: -0.14px;
    }
  }
`;
